import React, { useRef, useState, useEffect } from "react";
import videoExplain from '../../Assets/img/VIDEO_EXPLICATIVE_PRESSING360.mp4'

const ExplanatoryVideo = () => {
    const [isPlaying, setIsPlaying] = useState(false);
    const videoRef = useRef(null);

    const handlePlay = () => {
        setIsPlaying(true);
    };

    const handlePause = () => {
        setIsPlaying(false);
    };

    const handleClickOutside = (event) => {
        // Vérifie si le clic est à l'extérieur de la vidéo
        if (videoRef.current && !videoRef.current.contains(event.target)) {
            if (videoRef.current) {
                videoRef.current.pause(); // Met la vidéo en pause
            }
            setIsPlaying(false); // Met à jour l'état
        }
    };

    useEffect(() => {
        // Ajoute un écouteur d'événements global pour détecter les clics
        document.addEventListener("mousedown", handleClickOutside);

        // Nettoie l'écouteur d'événements pour éviter les fuites mémoire
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <>
            <div className="container-fluid explanatoryvideo p-5">
                <div className="row ">
                    <div className="container ">
                        <h2 className="text-white">Je possède également un pressing.</h2>
                        <p className="text-center text-white"> Avec les factures, les loyers et toutes les autres charges liées au pressing, il était difficile de joindre les deux bouts. <br /> Le problème venait du fait que mon personnel ne faisait pas les points honnêtement avec moi. <span className="fw-bold"> <br />Mais depuis que j'utilise Pressing 360, je n'entends plus 'Patron, ça ne marche pas'. Parce que maintenant, je sais exactement combien il y a en caisse. </span></p>
                        <h4 className="text-center text-white">  <span className="fw-bold"> Marc Kouadio </span></h4>
                        <div className={`video-container ${isPlaying ? "playing" : ""}`}  >
                            <video
                                width={isPlaying ? "1100" : "800"}
                                className="video img-fluid rounded"
                                onPlay={handlePlay}
                                onPause={handlePause}
                                controls
                            >
                                <source src={videoExplain} type="video/mp4" />
                                Votre navigateur ne supporte pas la lecture vidéo.
                            </video>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ExplanatoryVideo